import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EdpWidgetOnboardingWhatsNewComponent } from "./edp-widget-onboarding-whats-new.component";
import { TranslateModule } from "@ngx-translate/core";



@NgModule({
  declarations: [EdpWidgetOnboardingWhatsNewComponent],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [EdpWidgetOnboardingWhatsNewComponent]
})
export class EdpWidgetOnboardingWhatsNewModule { }
